<template>
  <div :class="['nt-theme', getTheme]">
    <label>{{ label }}</label>
    <div :id="id" class="nt-checkgroup">
      <nt-check
        :theme="theme"
        v-for="(item, i) in dataSource" :key="item.id"
        :item="item"
        :id="id + '-check-' + i"
        @onSelect="onSelect"
      >
      </nt-check>
    </div>
    <div class="nt-form-error" v-if="error">{{ error }}</div>
  </div>
</template>

<script>
import _ from 'lodash'
import NtCheck from './form-check.vue'

export default {
  name: 'nt-checkgroup',
  props: {
    id: {
      type: String,
      default: 'checkgroup'
    },
    label: {
      type: String,
      default: null
    },
    dataSource: {
      type: Array,
      default: []
    },
    validators: {
      type: Array,
      default: []
    },
    theme: {
      type: String,
      default: 'default'
    },
  },
  data() {
    return {
      selected: [],
      error: null
    }
  },
  watch: {
    '$parent.errors': function (values) {
      this.error = _.values(_.find(values, this.id, _.first))[0]
    }
  },
  computed: {
    getTheme() {
      return `nt-theme--${this.theme}`
    }
  },
  created() {
    const { formData, validators } = this.$parent.$data
    // Add to form initial values
    Object.assign(formData, {
      [this.id]: this.selected.length ? this.selected : null
    })
    // Add validators to form
    Object.assign(validators, {
      [this.id]: this.validators
    })
  },
  methods: {
    onSelect(item) {
      if (item.Checked) {
        this.addItem(item)
      } else {
        this.removeItem(item)
      }
      // this.selected = val !== this.selected ? val : null
      this.changeForm()
    },
    addItem(item) {
      this.selected.push(item.Value)
    },
    removeItem(item) {
      _.pull(this.selected, item.Value)
    },
    changeForm() {
      this.$parent.$emit('changeForm', {
        [this.id]: this.selected.length ? this.selected : null
      })
    }
  },
  components: {
    NtCheck
  }
}
</script>

<style lang="scss" scoped>
  .nt-theme {
    & .nt-checkgroup {
      display: flex;
      flex-wrap: wrap;

      & .radio {
        margin-bottom: 5px;
        &:not(:last-child) {
          margin-right: 20px;
        }
      }

      & .check {
        margin-bottom: 5px;
        &:not(:last-child) {
          margin-right: 20px;
        }
      }
    }
  }
</style>

